import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import {
  getImageUrl,
  getImageVariant,
} from '../../../../utility/util/util.service';
import { AvForm } from 'availity-reactstrap-validation';
import ImageDropzoneComponent from '../../form/dropzones/image-dropzone/image-dropzone.component';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import { connect } from 'react-redux';
import {
  closeModalSafely,
  getTranslationsCollapsable,
  handleSubmit,
} from './edit-menu.service';
import PropTypes from 'prop-types';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { fetchStore } from '../../../../redux/store/store.actions';
import {
  execOnSuccess,
  setIsEditMenuModalOpen,
} from '../../../../redux/modal/modal.actions';
import TextEditorField from '../../form/fields/TextEditorField';
import { useRef } from 'react';

const EditMenuModal = ({
  isOpen,
  onSuccess,
  store,
  intl,
  fetchStore,
  setIsEditMenuModalOpen,
}) => {
  const [targetMenu, setTargetMenu] = useState({});
  const [uploadImage, setUploadImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTranslationsOpen, setIsTranslationsOpen] = useState(false);
  const formRef = useRef(null);

  const userLocale = intl?.locale.substring(0, 2);
  const closeModal = () => setIsEditMenuModalOpen(false);

  useEffect(() => {
    if (isOpen && store?.menu) {
      setTargetMenu((store.menu && { ...store.menu }) || {});
      setUploadImage(null);
      const variant = getImageVariant('menuEntry');
      setPreviewUrl(getImageUrl(store.menu?.coverImage, variant) || null);
    } else {
      // reset modal on closing
      setUploadImage(null);
      setPreviewUrl(null);
      setTargetMenu({});
    }
  }, [isOpen, store]);

  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);
  const _handleSubmit = (event, errors, values) =>
    handleSubmit(
      event,
      errors,
      values,
      uploadImage,
      targetMenu,
      setIsSubmitting,
      setTargetMenu,
      closeModal,
      () => fetchStore(null, true, false, () => execOnSuccess(onSuccess)),
      store?.id,
    );
  const _getTranslationsCollapsable = () =>
    getTranslationsCollapsable(
      targetMenu,
      isTranslationsOpen,
      setIsTranslationsOpen,
      true,
      false,
      userLocale,
      true,
      false,
      setTargetMenu,
    );

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      title={intl.formatMessage({ id: 'menuCoverEditTitle' })}
      footer={
        <div className="align-content-center">
          <SaveSubmitButton
            className="m-auto"
            disabled={isSubmitting}
            isSubmitting={isSubmitting}
            onClick={() => formRef?.current.handleSubmit()}
          />
        </div>
      }
    >
      <div className="px-1">
        <AvForm ref={formRef} onSubmit={_handleSubmit} disabled={isSubmitting}>
          <div className="mt-2">
            <TextEditorField
              object={targetMenu}
              locale={userLocale}
              disabled={isSubmitting}
              setter={setTargetMenu}
            />
            <ImageDropzoneComponent
              propertyName="coverImage"
              object={targetMenu}
              setter={setTargetMenu}
              previewUrl={previewUrl}
              setPreviewUrl={setPreviewUrl}
              setUploadImage={setUploadImage}
              isDisabled={isSubmitting}
            />
            {_getTranslationsCollapsable()}
          </div>
        </AvForm>
      </div>
    </ModalSheet>
  );
};

EditMenuModal.propTypes = {
  isOpen: PropTypes.bool,
  onSuccess: PropTypes.func,
  intl: PropTypes.object,
  store: PropTypes.object,
  fetchMenuEntries: PropTypes.func,
  setIsEditMenuModalOpen: PropTypes.func,
  fetchStore: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isEditMenuModalOpen,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  setIsEditMenuModalOpen,
  fetchStore,
})(injectIntl(EditMenuModal));
